// <brook-loop-video>: a muted looping video that plays only while near the screen, and never
// again once the visitor pauses it with its optional toggle button ([data-loop-video-toggle]
// inside the element). It plays even for visitors who ask for reduced motion, like the GemPages
// videos elsewhere on the site; the toggle is their way to stop it.
// Used by brook-feature-images, brook-feature-rows and brook-video-hero.
if (!customElements.get('brook-loop-video')) {
  const shouldPlay = (el) => el.inView && !el.userPaused;
  const update = (el) => {
    if (!el.video) return;
    if (shouldPlay(el)) el.video.play().catch(() => {});
    else el.video.pause();
  };
  const observer =
    'IntersectionObserver' in window &&
    new IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting, target }) => {
          const el = target.closest('brook-loop-video');
          el.inView = isIntersecting;
          update(el);
        });
      },
      { rootMargin: '200px 0px' }
    );

  customElements.define(
    'brook-loop-video',
    class extends HTMLElement {
      onToggle = () => {
        // From what's on screen: Dawn's pauseAllMedia() can pause it behind our back.
        this.userPaused = !this.video.paused;
        this.toggle.setAttribute('aria-pressed', this.userPaused);
        update(this);
      };

      connectedCallback() {
        // Upgraded before its children parse (script loaded early): wait for them.
        if (!this.querySelector('video')) {
          this.waitForChildren = () => this.connectedCallback();
          document.addEventListener('DOMContentLoaded', this.waitForChildren, { once: true });
          return;
        }
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-loop-video-toggle]');
        this.toggle?.addEventListener('click', this.onToggle);
        // Hidden copies (e.g. the phone video on desktop) never intersect, so never load.
        if (observer) observer.observe(this.video);
      }

      disconnectedCallback() {
        if (this.waitForChildren) document.removeEventListener('DOMContentLoaded', this.waitForChildren);
        this.toggle?.removeEventListener('click', this.onToggle);
        if (this.video && observer) observer.unobserve(this.video);
      }
    }
  );
}
